import { css } from 'styled-system/css';

export const forgetPasswordStyles = {
	fontNormal: css({
		h: '12px',
		lineHeight: '12px',
		fontSize: '12px',
		fontWeight: '500',
		p: '30px 12px 0 12px'
	}),
	section: css({
		base: {
			justifyContent: 'start',
			p: '30px 12px 0 12px',
			md: {
				py: '84px',
			},
			'& .modalOverlay': {
				backdropFilter: 'none',
			}
		}
	}),
	modal: css({
		base: {
			w: '100%',
			maxW: '600px',
			borderRadius: '12px',
			zIndex: 'var(--modal-zindex)',
			overflow: 'hidden',

			_mdBelow: {
				maxW: 'none',
			}
		}
	}),
	root: css({
		display: 'flex',
		w: '100%',
		h: '100%',
		flexDirection: 'column',
		justifyContent: 'flex-start',

	}),
	header: css({
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		borderRadius: '12px 12px 0 0',
		borderBottom: '1px solid',
		borderBottomColor: 'jupiter.grey.40',
		bgColor: 'jupiter.grey.20',
		position: 'relative',
		w: '100%',
		color: 'jupiter.grey.80',
		textAlign: 'center',
		px: '12px',
	}),
	iconArrow: css({
		base: {
			color: 'jupiter.grey.60',
			display: 'none',
			w: '20px',
			h: '20px',
			_mdBelow: {
				display: 'block'
			}
		}
	}),
	iconClose: css({
		base: {
			display: 'block',
			position: 'absolute',
			cursor: 'pointer',
			right: '6px',
			top: '6px',
			'& .icon': {
				color: 'jupiter.grey.50',
				w: '24px',
				h: '24px',
			},
			md: {
				right: '12px',
				top: '8px',
				'& .icon': {
					w: '30px',
					h: '30px',
				},
			}
		}
	}),
	headerTitle: css({
		zIndex: 0,
		margin: '0',
		fontSize: '16px',
		lineHeight: '36px',
		fontWeight: '700',

		md: {
			fontSize: '20px',
			lineHeight: '48px',
		}
	}),
	headerIcon: css({
		aspectRatio: 1,
		objectFit: 'contain',
		objectPosition: 'center',
		width: '24px',
		borderRadius: '24px',
		alignSelf: 'flex-start',
		position: 'absolute',
		zIndex: 0,
		right: '12px',
		bottom: '12px',
		height: '24px',
	}),
	content: css({
		borderRadius: '0 0 12px 12px',
		w: '100%',
		bgColor: 'jupiter.grey.20',
		alignSelf: 'center',
		display: 'flex',
		justifyContent: 'flex-start',
		flexWrap: 'wrap',
		overflowY: 'auto',
		flex: '1 1 0%',
		pb: '24px',
	}),
	formContainer: css({
		alignSelf: 'flex-start',
		display: 'flex',
		minW: '240px',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'flex-start',
		w: '100%',
		padding: '24px 24px 6px 24px',
		gap: '24px',

		'& > form:last-of-type': {
			borderBottom: 'none', 
			paddingBottom: '0',
		},

		_mdBelow: {
			padding: '12px 12px 0px 12px',
			gap: '12px',
		}
	}),
	customText: css({
		alignSelf: 'stretch',
		flex: 1,
		borderRadius: '6px',
		bgColor: 'jupiter.grey.30',
		color: 'jupiter.grey.80',
		width: '100%',
		fontSize: '14px',
		fontWeight: '500',
		p: '12px',
	}),
	formSection: css({
		paddingBottom: '24px',
		borderBottom: '1px solid {colors.jupiter.grey.40}',
		display: 'flex',
		maxW: '100%',
		width: '544px',
		flexDirection: 'column',
		justifyContent: 'flex-start',
		gap: '24px'
	}),
	inputGroup: css({
		display: 'flex',
		width: '100%',
		flexDirection: 'column',
		justifyContent: 'flex-start',
		gap: '12px'
	}),
	inputErrorText: css({
		color: 'jupiter.error.100',
		h: '15px',
		fontSize: '12px',
		fontWeight: '500',
		mt: '3px'
	}),
	reqErrorText: css({
		color: 'jupiter.error.100',
		h: '15px',
		fontSize: '12px',
		fontWeight: '500',
		w: '100%',
		px: '3px',
	}),
	buttonContainer: css({
		display: 'flex',
		width: '100%',
		alignItems: 'center',
		fontSize: '14px',
		color: 'jupiter.grey.10',
		fontWeight: 700,
		textAlign: 'center',
		lineHeight: 1,
		flexDirection: 'column',
		mt: '12px',
		gap: '12px'
	}),
	signUpButton: css({
		bgColor: 'transparent',
		color: 'jupiter.main.primary',
		minH: '36px',
		fontSize: '14px',
		fontWeight: '700'
	}),
	loadingIcon: css({
		w: '24px',
		h: '24px',
	}),
	loginButton: css({
		minH: '36px',
		w: '100%',
	}),
	buttonText: css({
		alignSelf: 'stretch',
		margin: 'auto 0',
		padding: '0 6px',
	}),
	dropdown: css({
		padding: '0 12px!',
		'--dropdown-item-border': 'transparent',
		'&[data-open="true"]': {
			'& .icon--arrow-down': {
				transition: 'trasform 200ms ease-in',
				transform: 'rotate(180deg)',
			},
		},
		'& .dropdown__btn': {
			borderRadius: '6px',
			bgColor: 'transparent',
			p: 0,
			h: '100%'
		},
		'& .dropdown__current': {
			mr: '6px',
			overflow: 'visible',
		},
		'& .dropdown__container': {
			bgColor: 'jupiter.grey.10',
			boxShadow: '0 3px 9px rgba(0, 0, 0, .25)',
			w: '100%'
		},
		'& .dropdown__item': {
			minH: '30px',
			_supportHover: {
			},
			'&[data-selected="true"]': {
				bgColor: 'transparent',
				color: 'jupiter.main.primary',
			},
		},
		'& .icon': {
			w: '16px',
			h: '16px',
		}
	}),
};
  